import { action, computed, makeObservable, observable } from 'mobx'
import { task } from 'mobx-task'
import { DocumentCreationModalViewModel } from 'documents/views/DocumentCreationModal/DocumentCreationModalViewModel'
import { WellKnownDocumentTypeShortId } from 'documents/dtos/document-type'
import { isNotNil } from 'utils/object-util'

export default class JobProgressionRequestDraftApprovalViewModel {
  @observable
  documentViewModel: DocumentCreationModalViewModel | null = null

  constructor(
    private createDocumentCreationModalViewModel: () => DocumentCreationModalViewModel,
  ) {
    makeObservable(this)
  }

  @computed
  get canRequestDraftApproval(): boolean {
    const draftReturn = this.documentViewModel?.documentCreationItemVMs.find(
      (i) =>
        i.selectedType?.shortId === WellKnownDocumentTypeShortId.DraftReturn,
    )

    return isNotNil(draftReturn)
  }

  @action
  show() {
    this.documentViewModel?.show()
  }

  @action.bound
  close() {
    this.documentViewModel?.clearFiles()
    this.documentViewModel?.close()
  }

  requestDraftApproval = task.resolved(async () => {
    if (!this.documentViewModel) {
      return
    }

    const documentUploadResult = await this.documentViewModel.uploadFiles()
    if (!documentUploadResult) {
      return
    }

    this.close()
  })

  @action
  activate() {
    this.documentViewModel = this.createDocumentCreationModalViewModel()
  }
}
